import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { Button } from '../ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

export const ReaderControls = ({ children }) => {
  const [compact, setCompact] = useState(() => window.matchMedia('(max-width: 639px), (max-height: 650px)').matches);
  const [cramped, setCramped] = useState(false);
  const [open, setOpen] = useState(false);
  const inlineRef = useRef(null);
  const triggerRef = useRef(null);
  useEffect(() => {
    const query = window.matchMedia('(max-width: 639px), (max-height: 650px)');
    const update = () => { setCompact(query.matches); setCramped(false); };
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);
  useLayoutEffect(() => {
    if (compact || cramped || !inlineRef.current) return;
    const reader = inlineRef.current.closest('.reader-container');
    const area = reader?.querySelector('.reader-reading-viewport');
    if (!area) return;
    const update = () => {
      if (reader.clientWidth < 640 || area.clientHeight < 100) { setCramped(true); setOpen(false); }
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(area);
    observer.observe(reader);
    return () => observer.disconnect();
  }, [compact, cramped]);
  if (!compact && !cramped) return <div ref={inlineRef} className="reader-controls-stack" data-testid="reader-controls-inline">{children}</div>;
  return <Popover open={open} onOpenChange={setOpen}>
    <PopoverTrigger asChild><Button ref={triggerRef} variant="outline" size="sm" className="self-start shrink-0 gap-2" data-testid="reader-controls-toggle"><SlidersHorizontal className="h-4 w-4" />Reading controls</Button></PopoverTrigger>
    <PopoverContent forceMount align="start" className="w-[min(520px,calc(100vw-24px))] max-h-[min(70dvh,540px)] overflow-y-auto data-[state=closed]:hidden" onOpenAutoFocus={event => event.preventDefault()} onEscapeKeyDown={() => triggerRef.current?.focus()} data-testid="reader-controls-menu">
      <div className="reader-controls-stack" onClick={() => setOpen(false)}>{children}</div>
    </PopoverContent>
  </Popover>;
};